<template>
 <v-row>     
    <v-col cols="12" sm="12" md="3" lg="2" v-if="responseCount">     
      <div class="simple-data-control-container">
        <div class="simple-data-response-number mb-1">{{responseCount}}</div>
        <div class="simple-data-control-description">{{ $t("poll.lblResponses") }}</div>
      </div>
    </v-col>
    <v-col cols="12" sm="12" md="9" lg="10" v-if="responseCount">
      <ejs-chart
        ref="chart"
        style="display: block"
        :theme="theme"
        align="center"             
        :primaryXAxis="primaryXAxis"
        :primaryYAxis="primaryYAxis"
        :chartArea="chartArea"
        :width="width"
        :tooltip="tooltip"   
        @legendClick="onLegendClick"     
      >
        <e-series-collection>
          <e-series v-for="series in serieslist" :key="series.keyVal"
            :dataSource="series.data"
            type="StackingBar100"
            xName="x"
            yName="y"
            :name="series.text"
            width="1"
            :fill="series.color" 
          >
          </e-series>
        </e-series-collection>
      </ejs-chart>

    </v-col>
    <v-col class="text-subtitle-2 mt-5" cols="12" sm="12" md="9" lg="10" v-else>
      {{ $t("poll.msgNoResponses") }}
    </v-col>
 </v-row>
</template>
<style scoped>
</style>
<script>
import Vue from "vue";
import { colorCodes } from "../../utils/constant";
import { Browser } from "@syncfusion/ej2-base";
import {
  ChartPlugin,
  StackingBarSeries,
  Category,
  Tooltip,
  Legend,
} from "@syncfusion/ej2-vue-charts";
Vue.use(ChartPlugin);

let selectedTheme = location.hash.split("/")[1];
selectedTheme = selectedTheme ? selectedTheme : "Material";
let theme = (
  selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
).replace(/-dark/i, "Dark");

export default Vue.extend({

  props:{
      question: {
      type: [Object, Array],
    },
    countOptionAnswers: {
      type: [Object, Array],
    },
      responseCount:{
      type:Number,
      default:0,
    }
  },
  data: function () {
    return {
      theme: theme,     
      //Initializing Primary X Axis
      primaryXAxis: {
        valueType: "Category",
        majorGridLines: { width: 0 },
      },
      chartArea: {
        border: {
          width: 0,
        },
      },

      //Initializing Primary Y Axis
      primaryYAxis: {
        lineStyle: { width: 0 },
        majorTickLines: { width: 0 },
        
        edgeLabelPlacement: "Shift",
      },

      width: Browser.isDevice ? "100%" : "100%",

      tooltip: {
        format: '${point.x} : <b>${point.y} (${point.percentage}%)</b>',
        enable: true,
      },
    };
  },
  provide: {
    chart: [StackingBarSeries, Legend, Category, Tooltip],
  },
  mounted() {
      
  },
  computed:{
   serieslist(){ 
      let list = this.question.options.options;
     let seriesData = [];
     list.forEach((element, inc) => {
       let series = {
          "keyVal":element.value,
          "text":element.text,
          "data":this.getSeriesData(element),
          "color": this.getFillColor(inc) 
       }
       seriesData.push(series)
     });
     return seriesData;
   },
   
  },
 watch:{
   serieslist(val){
      const _this = this
      if(_this.$refs.chart){
        _this.$refs.chart.ej2Instances.dataBind()
        _this.$refs.chart.ej2Instances.refresh(); 
      }
   }
 },
  methods: {
    getSeriesData(option)
    {   
      let series=[];
      if(!this.question)
      {
        return series;
      }
      if(!this.question.selectedAnswer)
      {
        return series;
      }
      this.question.selectedAnswer.forEach(answer => {
      let vals = this.countOptionAnswers.filter((f)=>f.value===option.value && f.text===answer.text)
        series.push({
          x:answer.text,
          y:vals.length
        })
      });
      return series.reverse();
    },
     onLegendClick(args){
        args.cancel = true; // Prevents toggling the series visibility on legend click
      },
    getFillColor(inc) {
      if(colorCodes[inc]){
        return colorCodes[inc]
      }
      return "#" + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, "0")
    }
  },
});
</script>
<style scoped>
.simple-data-control-container {
  position: relative;
  height: 81px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  flex: 1 1 auto;
}
.simple-data-response-number {
  white-space: nowrap;
  color: #324154;
  font-size: 28px;
}

.simple-data-control-description {
  white-space: nowrap;
  color: #595959;
  font-size: 15px;
}
</style>